export const state = {
  deficiencyTypes: []
}
